import { useMemo } from 'react'

import { ReportFinancesDataReplenishmentCommon } from 'app/dataTypes/reports/data/common/financesSummaryReplenishment'

import {
  ColumnKey,
  columnKeysLeft,
  createColumnKeysMain,
  createColumnKeysMainHeaders,
  columnKeysRight,
  columnKeysRightHeaders,
  createHeaderCells,
  createDinamicColumnKey,
  columnKeysLeftHeaders,
  createHeaderCellsProps,
  createCellsProps,
  createFooterCellProps,
} from './tableColumns'

export function useBySchoolOrClassesTableData(
  data: ReportFinancesDataReplenishmentCommon,
  currency: string,
) {
  const tableData = useMemo(() => {
    const {
      periodType,
      dates,
      items,
      total: { totalByDateIndex, value: totalOverall },
    } = data
    return {
      columnKeysLeft,
      columnKeysLeftHeaders,
      columnKeysRight,
      columnKeysRightHeaders,
      columnKeysMain: createColumnKeysMain(dates),
      columnKeysMainHeaders: createColumnKeysMainHeaders(dates),
      header: createHeaderCells(dates, periodType, currency),
      headerProps: createHeaderCellsProps(dates),
      data: items.map(({ id, title, valuesByDateIndex, total }) => {
        return {
          rowKey: id,
          rowData: dates.reduce(
            (acc, date, index) => {
              const columnKey = createDinamicColumnKey(date)
              acc[columnKey] = { columnKey, value: valuesByDateIndex[index].value }
              return acc
            },
            {
              [ColumnKey.Subject]: { columnKey: ColumnKey.Subject as const, value: title },
              [ColumnKey.Total]: { columnKey: ColumnKey.Total as const, value: total.value },
            },
          ),
        }
      }),
      dataProps: createCellsProps(dates),
      total: [
        {
          rowKey: 'total',
          rowData: dates.reduce(
            (acc, date, index) => {
              const columnKey = createDinamicColumnKey(date)
              acc[columnKey] = { columnKey, value: totalByDateIndex[index].value }
              return acc
            },
            {
              [ColumnKey.Subject]: { columnKey: ColumnKey.Subject as const, value: 'ИТОГО' },
              [ColumnKey.Total]: {
                columnKey: ColumnKey.Total as const,
                value: totalOverall,
              },
            },
          ),
        },
      ],
      totalProps: createFooterCellProps(dates),
    }
  }, [data, currency])

  return tableData
}
